import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiSearchImpcs = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'searchImpcs',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, payload.params);
};

export default apiSearchImpcs;
